import { Component, Input } from '@angular/core';
import { EconomicValue } from '@pia/pia.shared';

@Component({
  selector: 'itl-economic-value-card',
  templateUrl: './economic-value-card.component.html',
  styleUrls: ['./economic-value-card.component.scss'],
})
export class EconomicValueCardComponent {
  @Input() economicValue: EconomicValue = EconomicValue.X;
  constructor() {}
}
